(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/socket-with-alert/assets/javascripts/socket-with-alert.js') >= 0) return;  svs.modules.push('/components/components/socket-with-alert/assets/javascripts/socket-with-alert.js'); 
var deadAlert;

svs.core.socket.on('dead', function() {
  if (!deadAlert) {
    deadAlert = new svs.components.Alert('Sidan uppdateras inte kontinuerligt.<br/>För att se senaste informationen behöver du ladda om sidan.');
  }

  deadAlert.show();
});

 })(window);